import script from "./AvaliacaoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AvaliacaoView.vue?vue&type=script&setup=true&lang=js"

import "./AvaliacaoView.vue?vue&type=style&index=0&id=7625fad3&lang=css"

const __exports__ = script;

export default __exports__